import React from "react";
import FormFieldError, { fieldClass } from "./FormFieldError";
import { LabeledField } from "./FormSection";

export default function FormTextField({
  id,
  label,
  required = false,
  error,
  className = "",
  as: Tag = "input",
  ...rest
}) {
  return (
    <LabeledField id={id} label={label} required={required}>
      <Tag
        id={id}
        className={`${fieldClass(error)} ${className}`.trim()}
        aria-invalid={Boolean(error)}
        aria-describedby={error ? `${id}-error` : undefined}
        {...rest}
      />
      {error ? <FormFieldError id={`${id}-error`}>{error}</FormFieldError> : null}
    </LabeledField>
  );
}
